import React from "react";
import { View, StyleSheet, ActivityIndicator } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import { UnChecked, Checked } from "../../svgs/common";
import { useAppConfig } from "../../../AppConfigProvider";

function Notifications({ onChange, isEnabled, errorMessage, buttonText }) {
  const { primaryColor } = useAppConfig();

  return (
    <>
      <View style={styles.notificationsContainer}>
        <CustomButton
          styleType="transparent"
          role="checkbox"
          aria-checked={isEnabled}
          aria-label="checkbox button"
          accessibilityLabel="checkbox button"
          style={styles.checkboxButton}
          leftIcon={
            isEnabled ? (
              <Checked accessibilityLabel="checkbox button checked" role="img" alt="checkbox button checked" />
            ) : (
              <UnChecked accessibilityLabel="checkbox button unchecked" role="img" alt="checkbox button unchecked" />
            )
          }
          onPress={onChange}
        />
        <CustomText text={buttonText} style={styles.checkboxText} />
      </View>
      {errorMessage && (
        <View style={styles.notificationsContainer}>
          <CustomText text={errorMessage} useTranslationText={false} style={{ color: "#E57373" }} />
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  notificationsContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  checkboxButton: {
    padding: 0,
    marginRight: 10,
  },
  checkboxText: {
    fontSize: 14,
  },
});

export default Notifications;
